
import './App.css';
import React from 'react';
import { Header } from './component/Header';
// import { Todolist } from './component/Todolist';


function App() {

  

  return (
    <React.Fragment>
    
    <Header/>
    </React.Fragment>
  );
}

export default App;
